import S_guidelineStatus from '@/service/api/v1/guidelineStatus';
import H_relatedModuleDeleteInfo from '@/helpers/relatedModuleDeleteInfo';

const DELETE_IN_USE_TEXT = '下列項目正在使用此施行狀態，無法刪除';

export default {
  setDropdownCustomItems(rawItems) {
    const setItems = (rawItems) => {
      return rawItems.map(({
        id: value,
        name: text,
        sequence = null,
      }) => ({
        text,
        value,
        sequence,
      }));
    };
    return [{
      menu: setItems(rawItems),
      isCustom: true,
    }];
  },
  setDeleteInfo(rawData) {
    return H_relatedModuleDeleteInfo.setDeleteInfo(rawData, DELETE_IN_USE_TEXT);
  },
  async setDeletePopupInfo($event) {
    const {value: statusId} = $event;
    const res = await S_guidelineStatus.show(statusId);
    return this.setDeleteInfo(res);
  },
}